import {
  BodyText,
  DataText,
  HeadingText,
  NextTooltipContent,
  Tooltip,
  TooltipIcon,
  TooltipProvider,
  TooltipTrigger,
} from '@cint/wonderment';

interface ChartHeaderProps {
  title: string;
  subtitle?: string;
  headerTooltip?: string;
  hasTotal?: boolean;
  total?: number;
  formatValue?: (val: number | string) => string | JSX.Element;
  headerStats?: { label: string; value: number | string }[];
  titleClassName?: string;
  hasMultipleSeries?: boolean;
}

export const ChartHeader = ({
  title,
  subtitle,
  headerTooltip,
  hasTotal = true,
  total,
  formatValue,
  headerStats,
  titleClassName,
  hasMultipleSeries = false,
}: ChartHeaderProps) => (
  <div>
    <div className="flex items-center gap-1 mb-2">
      <HeadingText
        fontWeight="bold"
        variant="h6"
        className={titleClassName ? ` ${titleClassName}` : ''}
      >
        {title}
      </HeadingText>
      {headerTooltip && (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger>
              <TooltipIcon />
            </TooltipTrigger>
            <NextTooltipContent>{headerTooltip}</NextTooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}
    </div>
    {hasTotal && (total >= 0 || headerStats) && (
      <div className="flex gap-8">
        {(headerStats?.length
          ? headerStats
          : [{ label: 'Total per timeframe', value: total }]
        ).map(({ label, value }) => (
          <div key={label} className="flex flex-col items-start">
            <BodyText size="sm">{label}</BodyText>
            <DataText className="mt-2 mb-6" size="4xl">
              {value != null &&
                typeof value === 'number' &&
                (formatValue
                  ? formatValue(value)
                  : new Intl.NumberFormat().format(value))}
              {typeof value !== 'number' && value}
            </DataText>
          </div>
        ))}
      </div>
    )}
    {subtitle && (
      <BodyText
        size="sm"
        fontWeight="medium"
        className={hasMultipleSeries ? 'mb-6' : ''}
      >
        {subtitle}
      </BodyText>
    )}
  </div>
);
